<template>
  <div>
    <!-- Email Input -->
    <div class="col form-group" style="margin-bottom: 44px">
      <input
        id="email"
        v-model="obj.email"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        class="w-100"
        placeholder="E-mail"
      />
    </div>

    <!-- Confirm Email Input -->
    <div class="col form-group">
      <input
        id="emailConfirmation"
        v-model="obj.emailConfirmation"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        class="w-100"
        placeholder="Confirme seu E-mail"
        @keyup.enter="validateFields"
        @paste="blockPaste"
      />
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'
import { loginFB } from '../../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'Email',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('email').focus()
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    /* Helpers */
    blockPaste() {
      return false
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: 'Atenção',
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.checkEmail(this.obj.email)) {
        const warningMsg = 'É necessário um Email válido.'
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')

        hasErrors = true
      }

      if (this.obj.email !== this.obj.emailConfirmation) {
        const warningMsg = 'Os emails informados são diferentes.'
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')

        hasErrors = true
      }

      if (!hasErrors) {
        this.checkExistingEmail(this.obj.cpf || null, this.obj.email)
      }
    },
    checkEmail(email) {
      const emailRegex = /\S+@\S+\.\S+/
      return emailRegex.test(email)
    },
    async checkExistingEmail(cpf, email) {
      try {
        const response = await lFB.checkUserEmail(this.config.name, cpf, email)
        if (response.header.codigo !== 1) {
          this.toastMessage = response.header.msg || 'Erro desconhecido ao verificar e-mail.'
          this.makeToast('warning')
          return
        }
        this.$store.commit('updateRegistrationObject', this.obj)
        this.$emit('next')
      } catch (err) {
        this.addRegistrationError({
          msg: err,
        })
        this.toastMessage = err
        this.makeToast('warning')
      }
    },
  },
}
</script>
